import { FormattedMessage } from 'react-intl';
import { PropsWithChildren, ReactElement, ReactNode } from 'react';

import { PoolButton } from '../buttons';
import { PoolModal } from './pool-modal';
import { PoolModalActions } from './components/pool-modal-actions';
import { PoolModalContent } from './components/pool-modal-content';
import { PoolModalTitle } from './components/pool-modal-title';

export interface PoolConfirmationModalProps {
    open: boolean;
    title?: ReactNode;
    action?: ReactNode;
    isSuccessDialog?: boolean;
    onConfirm?: () => void;
    onCancel?: () => void;
}

export const PoolConfirmationModal = (props: PropsWithChildren<PoolConfirmationModalProps>): ReactElement => {
    const { open, onConfirm, onCancel, action, title, isSuccessDialog, children } = props;

    const singleButton = !onConfirm || !onCancel;

    return (
        <PoolModal open={open} maxWidth="sm">
            <PoolModalTitle>{title || <FormattedMessage id="app.common.modal.warningHeader" />}</PoolModalTitle>
            <PoolModalContent>{children || <FormattedMessage id="app.common.modal.warning" />}</PoolModalContent>
            <PoolModalActions sx={{ flexDirection: singleButton ? 'row-reverse' : 'row' }}>
                {onCancel && (
                    <PoolButton variant="outlined" onClick={onCancel}>
                        <FormattedMessage id="app.common.cancel" />
                    </PoolButton>
                )}
                {onConfirm && (
                    <PoolButton color={isSuccessDialog ? 'primary' : 'error'} onClick={onConfirm} data-testid="confirm">
                        {action || <FormattedMessage id="app.common.yes" />}
                    </PoolButton>
                )}
            </PoolModalActions>
        </PoolModal>
    );
};
